export const plans = [
  {
    inputValue: 'Monthly',
    inputId: 'plan-monthly',
    planHtmlFor: 'plan-monthly',
    planStyle: 'md:pb-9',
    imageStyle: 'w-9 md:mb-2',
    image: '/images/monthly-subscription-box-plan.png',
    alt: 'Monthly subscription box plan',
    paraOne: 'Monthly - $108',
    paraTwo: ' ',
    paraThree: '1 lens box',
    paraThreeDouble: '2 lens boxes',
    boxesSummary: '1 box - 30 lenses per box',
  },
  {
    inputValue: 'Quarterly',
    inputId: 'plan-quarterly',
    planHtmlFor: 'plan-quarterly',
    planStyle: '',
    imageStyle: 'w-8 md:mb-2',
    image: '/images/hydra-boost-quaterly-plan.png',
    alt: 'Quarterly subscription box plan',
    paraOne: 'Quarterly - $108',
    paraTwo: '(7% discount)',
    paraThree: '3 lens boxes',
    paraThreeDouble: '6 lens boxes',
    boxesSummary: '3 boxes - 30 lenses per box',
  },
  {
    inputValue: 'Bi-Annual',
    inputId: 'plan-bi-annually',
    planHtmlFor: 'plan-bi-annually',
    planStyle: 'md:pt-7',
    imageStyle: 'w-14 md:mb-2',
    image: '/images/bi-annual-subscription-box.png',
    alt: 'Bi-annual subscription box plan',
    paraOne: 'Bi-annual - $108',
    paraTwo: '(7% discount)',
    paraThree: '6 lens boxes',
    paraThreeDouble: '12 lens boxes',
    boxesSummary: '6 boxes - 30 lenses per box',
  },
];

export const plansSum = [
  {
    imageStyle: 'w-9 mb-2',
    image: '/images/monthly-subscription-box-plan.png',
    alt: 'Monthly subscription box plan',
    paraOne: 'Monthly',
    paraTwo: '60 contacts',
  },
  {
    imageStyle: 'w-8 mb-2',
    image: '/images/hydra-boost-quaterly-plan.png',
    alt: 'quaterly subscription box plan',
    paraOne: 'Quaterly',
    paraTwo: '180 contacts',
    paraThree: '7% discount',
  },
  {
    imageStyle: 'w-20 mb-2',
    image: '/images/bi-annual-subscription-box.png',
    alt: 'annualy subscription box plan',
    paraOne: 'Bi-annual',
    paraTwo: '360 contacts',
    paraThree: '12% discount',
  },
];
